
import { Doughnut, mixins } from 'vue-chartjs';

const { reactiveProp } = mixins;

export default {
	data() {
		return {
			// options: {},
		};
	},
	extends: Doughnut,
	mixins: [reactiveProp],
	props: {
		options: {
			required: false,
			type: Object,
			default: () => ({
				responsive: true,
				width: 100,
				height: 100,
				legend: {
					position: 'bottom',
					labels: {
						padding: 20,
					},
				},
				layout: {
					padding: {
						left: 5,
						right: 5,
						top: 0,
						bottom: 0,
					},
				},
			}),
		},
	},

	mounted() {
		// this.chartData is created in the mixin.
		// If you want to pass options please create a local options object
		this.renderChart(this.chartData, this.options);
	},
};



// WEBPACK FOOTER //
// ./_source/javascripts/components/charts/DougChart.js